import { render, staticRenderFns } from "./RegisterCompany.vue?vue&type=template&id=2ceac1fe&scoped=true&"
import script from "./RegisterCompany.vue?vue&type=script&lang=js&"
export * from "./RegisterCompany.vue?vue&type=script&lang=js&"
import style0 from "../../../public/assets/css/intern-dashboard.css?vue&type=style&index=0&id=2ceac1fe&scoped=true&lang=css&"
import style1 from "./RegisterCompany.vue?vue&type=style&index=1&id=2ceac1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceac1fe",
  null
  
)

export default component.exports